module.exports = __webpack_public_path__ + "static/media/cq_ordinamento_asc.b5dbeba1.svg";